module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1528-117b54af709df2aa6eb3e52333599cb2.png";